import { ArrowRight } from 'lucide-react';
import posthog from 'posthog-js';

import type { components } from 'wg-api-sdk';

import PlatformLink from '@/components/common/PlatformLink';
import { useEmail } from '@/components/providers/EmailProvider/EmailProvider';
import { Button } from '@/components/shadcn/button';
import useSelectedParty from '@/features/analysis/hooks/useSelectedParty';

type Props = {
  action: components['schemas']['OnesuranceAction'];
};

export default function ActionLink({ action }: Props) {
  const { email } = useEmail();
  const party = useSelectedParty();

  const handleClick = () => {
    posthog.capture('Onesurance action clicked', {
      actionType: action.type,
      order: action.order,
      hasUrl: Boolean(action.url),
      messageId: email?.messageId,
      partyId: party?.id,
    });
  };

  return (
    <Button
      variant={action.order === 1 ? 'default' : 'secondary'}
      size="xs"
      asChild
    >
      <PlatformLink
        to={action.url ?? ''}
        rel="noopener noreferrer"
        target="_blank"
        onClick={handleClick}
      >
        {action.title}

        <ArrowRight />
      </PlatformLink>
    </Button>
  );
}
